import {
  FeedbackIcon_default
} from "./chunk-G2EOBCRW.mjs";
export {
  FeedbackIcon_default as default
};
